import { get } from '../utils/axios'

export const getDashboardOrgAPI = async () => {
  return await get('dashboard/org')
}

export const getDashboardTypeAPI = async () => {
  return await get('dashboard/type')
}

export const getDashboardProbationAPI = async () => {
  return await get('dashboard/probation')
}

export const getDashboardTurnoverAPI = async () => {
  return await get('dashboard/turnover')
}

